import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {resolveApiBase} from '../../core/api-base';

// TermDecision mirrors backend/register/main.go TermDecision (Story 38.8).
export interface TermDecision {
  termId: string;
  decision: 'accepted' | 'declined';
}

// EligibleTerm mirrors the GET /terms/eligible response (Story 38.8).
export interface EligibleTerm {
  id: string;
  kind: 'term' | 'permission';
  number: string;
  version: number;
  resume: string;
  fullText: string;
}

export interface RegisterRequest {
  client_id: string;
  email: string;
  password: string;
  termDecisions: TermDecision[];
  recaptcha_token?: string;
  // Story 54.4 — the ALTCHA payload, sent only while ALTCHA is selected.
  altcha_payload?: string;
}

// Deliberately EMPTY (Story 45.1 / EO-268) — the wire body is `{}` for both a
// fresh registration and a duplicate-email attempt, so the two are
// byte-identical and the response carries no enumeration signal. Do not add
// fields back without checking backend/identity/internal/register/main.go's
// RegisterResponse first.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface RegisterResponse {}

@Injectable({
  providedIn: 'root'
})
export class SignupService {
  private readonly http = inject(HttpClient);

  register(request: RegisterRequest): Observable<RegisterResponse> {
    return this.http.post<RegisterResponse>(
      `${resolveApiBase()}/register`,
      request
    );
  }

  getEligibleTerms(clientId: string): Observable<EligibleTerm[]> {
    return this.http.get<EligibleTerm[]>(
      `${resolveApiBase()}/terms/eligible`,
      {params: {client_id: clientId}}
    );
  }
}
